import {
    CREATETPA,
    CREATETPACHARGE,
    DELETETPA,
    DELETETPACHARGE,
    GETALLTPA,
    GETTPA,
    GETTPACHARGE,
    UPDATETPA,
    UPDATETPACHARGE,
    axios,
    baseURL,

} from "./types";


export const createTPA = (data) => (dispatch) => {
    var config = {
      method: "post",
      url: baseURL + "/api/setuptpa/create",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data:data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: CREATETPA,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const getTPA = (data) => (dispatch) => {
    console.log(data)
    var config = {
      method: "post",
      url: baseURL + "/api/setuptpa/getall",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: GETTPA,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const getAllTPA = (data) => (dispatch) => {
    console.log(data)
    var config = {
      method: "post",
      url: baseURL + "/api/setuptpa/getalltpa",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: GETALLTPA,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const updateTPA = (data) => (dispatch) => {
    var config = {
      method: "patch",
      url: baseURL + "/api/setuptpa/update",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: UPDATETPA,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const deleteTPA = (data) => (dispatch) => {
    var config = {
      method: "delete",
      url: baseURL + "/api/setuptpa/delete",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: DELETETPA,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  
export const createTPACharge = (data) => (dispatch) => {
    var config = {
      method: "post",
      url: baseURL + "/api/setuptpacharge/create",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data:data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: CREATETPACHARGE,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const getTPACharge = (data) => (dispatch) => {
    console.log(data)
    var config = {
      method: "post",
      url: baseURL + "/api/setuptpacharge/getall",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: GETTPACHARGE,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const updateTPACharge = (data) => (dispatch) => {
    var config = {
      method: "patch",
      url: baseURL + "/api/setuptpacharge/update",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: UPDATETPACHARGE,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  export const deleteTPACharge = (data) => (dispatch) => {
    var config = {
      method: "delete",
      url: baseURL + "/api/setuptpacharge/delete",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
  
    axios(config)
      .then(function (response) {
        dispatch({
          type: DELETETPACHARGE,
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  